import type { EvergladesProductsApiSuccess, IntentType, Variation } from '@shared/types/types.ts';
import { isBlackFridayRuleRequested } from '@tilelist/domain/black-friday-slider/BlackFridaySlider.ts';
import { isGalleryLayoutParam } from '@tilelist/domain/composition/GalleryLayout.ts';
import { buildPageLayout } from '@tilelist/domain/composition/PageLayoutBuilder.ts';
import { isFirstPage } from '@tilelist/domain/composition/Paging.ts';
import { evaluateTeaserBoost, loadBoostedItems } from '@tilelist/domain/composition/TeaserBoost.ts';
import type { TileListPageLayout } from '@tilelist/domain/composition/TileListPage.ts';
import { isComboTileRequested } from '@tilelist/domain/feature-visibility/ComboTile.ts';
import type { PageLoadContext, PageLoadStrategy } from './PageLoadStrategy.ts';

/*                                                                                                    */
type VariationLoader = {
    loadVariations(variationIds: string[]): Promise<Variation[]>;
};

/**
 *
 *
 *
 *
 *
 *
 */
export class FullTileListStrategy implements PageLoadStrategy {
    constructor(private variationLoader: VariationLoader) {}

    intents(ctx: PageLoadContext): IntentType[] {
        const { queryParams, onex } = ctx;
        const isTopSeller = !queryParams.sortiertnach || queryParams.sortiertnach === 'topseller';
        const firstPage = isFirstPage(queryParams);

        const similar: IntentType[] = firstPage ? ['similar'] : [];
        const layoutIntent: IntentType[] = !queryParams.l ? ['layout'] : [];
        /*                                                                             */
        const blackFriday: IntentType[] = isBlackFridayRuleRequested(onex, firstPage) ? ['blackFriday'] : [];

        /*                                                                                     */
        /*                                                                                               */
        if (isComboTileRequested(onex, firstPage)) {
            const sponsored: IntentType[] = isTopSeller ? ['sponsored'] : [];
            return ['ranked', ...sponsored, ...similar, 'context', 'inspiration', ...blackFriday, ...layoutIntent];
        }

        if (onex.isExperimentGroup('SPA_VIA_SEARCH', 'E3886B')) {
            /*                                                      */
            return ['interleaved', ...similar, 'context', ...blackFriday, ...layoutIntent];
        }

        /*                  */
        const sponsored: IntentType[] = isTopSeller ? ['sponsored'] : [];
        return ['ranked', ...sponsored, ...similar, 'context', ...blackFriday, ...layoutIntent];
    }

    async compose(response: EvergladesProductsApiSuccess, ctx: PageLoadContext): Promise<TileListPageLayout> {
        const teaserBoost = evaluateTeaserBoost(ctx.onex, ctx.queryParams);
        const boostedItems = teaserBoost.shouldBoost
            ? await loadBoostedItems({
                  variationIds: ctx.queryParams.variationIds ?? [],
                  variationLoadingService: this.variationLoader,
              })
            : [];

        const { l, c } = ctx.queryParams;
        const compositionQuery = { c, l: isGalleryLayoutParam(l) ? l : undefined };

        return buildPageLayout(response, ctx.requestContext, compositionQuery, ctx.onex, {
            /*                                                               */
            boostedItems,
            teaserVariationBoostShouldBeTracked: teaserBoost.whatIf,
        });
    }
}
